import Vue from 'vue'
import store from '../store.js'
import xhrModule from './xhrModule.js'

var globalErrorHandler = {
	init: function () {
		// catch VueJS errors
		Vue.config.errorHandler = (err, vm, info) => {
			// show error in console
			console.error(err)

			if (/loading chunk \d* failed./i.test(err) || /Unexpected token '<'/i.test(err)) {
				window.location.reload()
			}

			// bundle error data
			var errorData = JSON.stringify({
				'error': err.toString(),
				'info': info
			})

			this.postError(errorData)
		}

		// catch all other JS errors
		window.onerror = (msg, src, linenum, colnum, error) => {
			var errorData = JSON.stringify({
				'msg': msg,
				'src': src,
				'linenum': linenum,
				'colnum': colnum,
				'error': JSON.stringify(error)
			})
			this.postError(errorData)
		}
	},

	postError: function (errorData) {
		// current url
		var href = window.location.href
		var origin = window.location.origin
		var pageUrl = href.split(origin)[1]

		// error data
		var data = {
			'error': errorData,
			'page': pageUrl,
			'user': store.getters.username
		}
		var json = JSON.stringify(data)

		var url = '/cms/api/log/error'
		xhrModule.post(url, json, function (error) {
			console.log('error posted: ', error)
		})
	}
}

export default globalErrorHandler
